import interact from 'interactjs';
import { gsap } from 'gsap';
import './wave-grid.js';
import './about.js';

const logo = document.querySelector('#logo');
const button = document.querySelector('.app__logo');
const root = document.documentElement;
const current = { oo: 0, o: 0 };
const limits = {};
let white = false;
let dragged = false;
let dragInteraction;
let animation;

function render(key, position) {
  const { min, max } = limits[key];
  current[key] = Math.max(min, Math.min(max, position));
  document.querySelector(`#drag-${key}`).style.transform = `translateX(${current[key]}px)`;
}

button.addEventListener('pointerdown', () => { dragged = false; });
for (const key of ['oo', 'o']) {
  const handle = document.querySelector(`#drag-${key}`);
  const track = handle.previousElementSibling.getBBox();
  const bounds = handle.getBBox();
  limits[key] = {
    min: track.x - bounds.x,
    max: track.x + track.width - bounds.x - bounds.width,
  };
  render(key, 0);

  interact(handle).draggable({
    startAxis: 'x',
    lockAxis: 'x',
    inertia: true,
    modifiers: [interact.modifiers.restrictRect({ restriction: 'parent' })],
    listeners: {
      start(event) {
        dragged = true;
        dragInteraction = event.interaction;
        animation?.kill();
      },
      move(event) {
        render(key, current[key] + event.dx / logo.getScreenCTM().a);
      },
    },
  });
}

button.addEventListener('click', (event) => {
  if (dragged && event.detail !== 0) return;
  dragInteraction?.stop();
  animation?.kill();
  white = !white;
  root.style.setProperty('--bgColor', white ? '#ffffff' : '#ff0058');
  root.style.setProperty('--gdColor', white ? '#ff0058' : '#ffffff');
  document.querySelector('meta[name="theme-color"]').content = white ? '#ffffff' : '#ff0058';
  button.setAttribute('aria-pressed', String(white));
  const rect = button.getBoundingClientRect();
  root.dispatchEvent(new CustomEvent('themechange', { detail: {
    white,
    clientX: event.detail ? event.clientX : rect.left + rect.width / 2,
    clientY: event.detail ? event.clientY : rect.top + rect.height / 2,
  } }));
  animation = gsap.to(current, {
    oo: white ? limits.oo.max : 0,
    o: white ? limits.o.min : 0,
    duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 0.25,
    ease: 'power1.out',
    onUpdate: () => {
      for (const key of ['oo', 'o']) render(key, current[key]);
    },
  });
});
